import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';

import useStyles from './styles';

interface DashboardBigButtonProps {
  title: React.ReactNode;
  icon: React.ReactNode;
  description?: React.ReactNode;
  to: string;
  type: 'building' | 'health' | 'vaccine' | 'quiz';
}

const DashboardBigButton = ({
  icon,
  title,
  description,
  to,
  type = 'building',
}: DashboardBigButtonProps) => {
  const classes = useStyles();

  return (
    <Button
      component={Link}
      to={to}
      endIcon={icon}
      className={clsx(classes.button, classes[type])}
    >
      <Box>
        <Typography variant="h2">{title}</Typography>
        {description && <Typography>{description}</Typography>}
      </Box>
    </Button>
  );
};

export default DashboardBigButton;
